export default __webpack_public_path__ + "3da5e123444a29f244a2c637b174eea7.svg";